<app-header></app-header>
<div class="body-container clearfix">
    <form [formGroup]="bankInfo.form" (ngSubmit)="uploadBankInfo()">
		<div class="row" *ngIf="!production">
			<button class="btn btn-primary btn-lg auto-populate" (click)="onCompleteInformationClick(); $event.preventDefault();">
				<i class="fa fa-check"></i>
			</button>
		</div>
        <div class="row title">
            <div class="col-12">
                ACH Payments are required for all transactions
            </div>
        </div>
        <div class="row title">
            <div class="col-12">
                Please provide your business bank account information below.
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="accountRoutingNumber" [ngClass]="{ 'color-red': submitted && form.accountRoutingNumber.errors }">Bank Routing Number: *</label>
                <input type="text" formControlName="accountRoutingNumber" class="form-control" id="accountRoutingNumber"
                    placeholder="Bank Routing Number" name="accountRoutingNumber"
                    [ngClass]="{ 'is-invalid': submitted && form.accountRoutingNumber.errors }" [showMaskTyped]="true" mask="000000000">
                <div *ngIf="submitted && form.accountRoutingNumber.errors" class="invalid-feedback">
                    <div *ngIf="form.accountRoutingNumber.errors.required">
                        You must supply the bank routing number.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="bankName" [ngClass]="{ 'color-red': submitted && form.bankName.errors }">Bank Name: *</label>
                <input type="text" formControlName="bankName" class="form-control" id="bankName"
                    placeholder="Bank Name" name="bankName"
                    [ngClass]="{ 'is-invalid': submitted && form.bankName.errors }">
                <div *ngIf="submitted && form.bankName.errors" class="invalid-feedback">
                    <div *ngIf="form.bankName.errors.required">
                        You must supply the bank name.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="city" [ngClass]="{ 'color-red': submitted && form.city.errors }">Bank City: *</label>
                <input type="text" formControlName="city" class="form-control" id="city"
                    placeholder="Bank City" name="city"
                    [ngClass]="{ 'is-invalid': submitted && form.city.errors }">
                <div *ngIf="submitted && form.city.errors" class="invalid-feedback">
                    <div *ngIf="form.city.errors.required">
                        You must supply the bank city.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="state" [ngClass]="{ 'color-red': submitted && form.state.errors }">Bank State: *</label>
                <select formControlName="state" id="state" class="form-control" name="businessType"
                    [ngClass]="{ 'is-invalid': submitted && form.state.errors }">
                    <option *ngFor="let state of states" [ngValue]="state.code">
                        {{state.name}}
                    </option>
                </select>
                <div *ngIf="submitted && form.state.errors" class="invalid-feedback">
                    <div *ngIf="form.state.errors.required">
                        You must supply the bank state.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="accountName" [ngClass]="{ 'color-red': submitted && form.accountName.errors }">Name on Bank Account (Business Name): *</label>
                <input type="text" formControlName="accountName" class="form-control" id="accountName"
                    placeholder="Name on Bank Account (Business Name)" name="accountName"
                    [ngClass]="{ 'is-invalid': submitted && form.accountName.errors }">
                <div *ngIf="submitted && form.accountName.errors" class="invalid-feedback">
                    <div *ngIf="form.accountName.errors.required">
                        You must supply the bank account name.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="accountType" [ngClass]="{ 'color-red': submitted && form.accountType.errors }">Account Type: *</label>
                <select formControlName="accountType" id="accountType" class="form-control" name="accountType"
                    [ngClass]="{ 'is-invalid': submitted && form.accountType.errors }">
                    <option *ngFor="let bankType of bankTypes" [ngValue]="bankType.code">
                        {{bankType.name}}
                    </option>
                </select>
                <div *ngIf="submitted && form.accountType.errors" class="invalid-feedback">
                    <div *ngIf="form.accountType.errors.required">
                        You must supply the bank account type.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="accountNumber" [ngClass]="{ 'color-red': submitted && form.accountNumber.errors }">Bank Account Number: *</label>
                <input type="text" formControlName="accountNumber" class="form-control" id="accountNumber"
                    placeholder="Bank Account Number" name="accountNumber"
                    [ngClass]="{ 'is-invalid': submitted && form.accountNumber.errors }">
                <div *ngIf="submitted && form.accountNumber.errors" class="invalid-feedback">
                    <div *ngIf="form.accountNumber.errors.required">
                        You must supply the bank account number.
                    </div>
                </div>
            </div>
            <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label for="accountNumberConfirm" [ngClass]="{ 'color-red': submitted && form.accountNumberConfirm.errors }">Bank Account Number (Confirm): *</label>
                <input type="text" formControlName="accountNumberConfirm" class="form-control" id="accountNumberConfirm"
                    placeholder="Bank Account Number (Confirm)" name="accountNumberConfirm"
                    [ngClass]="{ 'is-invalid': submitted && form.accountNumberConfirm.errors }">
                <div *ngIf="submitted && form.accountNumberConfirm.errors" class="invalid-feedback">
                    <div *ngIf="form.accountNumberConfirm.errors.required">
                        You must supply the bank account number.
                    </div>
					<div *ngIf="form.accountNumberConfirm.errors.mustMatch">
						Bank account number must match
					</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="e-sign-button" (click)="uploadBankInfo();" *ngIf="!bankInfo.form.invalid">
                <img src="/assets/images/docusign.svg" />
                <div class="e-sign-button-text">
                    <div class="row e-sign-title">
                        <div class="col-12">E-Sign Now</div>
                    </div>
                    <div class="row e-sign-body">
                        <div class="col-12">Click here to review and e-sign the agreement now</div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<app-footer></app-footer>